import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";

import { DatePicker, Button, Row, Col } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";
import _ from "lodash";
import moment from "moment";
import classNames from "classnames";
import "./customStyle.css";

import * as actions from "../../../../store/actions/indexes";
import commonConfig from "../../../commonConfig.json";
import { getConfigDate } from "../../../../utils/generalProcessing";
import usePrevious from "../../../../utils/usePrevious";
let datePickerConfigs = commonConfig.datePickerProps;
// let customTabView = commonConfig.customTabView;

const { RangePicker } = DatePicker;

const Rangepicker = (props) => {
  const [selectedRange, setSelectedRange] = useState([]);
  const [initSelectedRange, setInitSelectedRange] = useState([]);
  const [enabledRange, setEnabledRange] = useState({ type: "", val: [] });
  const [modeExtensions, setModeExtensions] = useState([]);
  const [currentModeExtension, setCurrentModeExtension] = useState("");
  const [rangeCalandarVisibilityClass, setRangeCalandarVisibilityClass] =
    useState("show");
  const [pickerOpen, setPickerOpen] = useState(false);
  const [disableApply, setDisableApply] = useState(true);
  const [dataApplied, setDataApplied] = useState(false);
  const [calendarChange, setCalendarChange] = useState(false);
  // const [currentCalendarPanel, setcurrentCalendarPanel] = useState([]);

  const dispatch = useDispatch();

  const isControlledFiltersOpen = useSelector(
    (state) => state.controlledComponentsReducer.isControlledFiltersOpen,
    shallowEqual
  );
  // const prevCalendarPanel = usePrevious(currentCalendarPanel);

  const onClickExtension = (type) => {
    if (type === datePickerConfigs.modeExtension.CUSTOM_RANGE) {
      setCurrentModeExtension(type);
    } else {
      let copyOfFilterStates = JSON.parse(
        JSON.stringify(isControlledFiltersOpen)
      );
      if (props.apply === datePickerConfigs.apply.ONAPPLY) {
        for (const key in copyOfFilterStates) {
          if (key === props.indexName) {
            copyOfFilterStates[key] = false;
            break;
          }
        }
        dispatch(actions.setControlledFiltersOpen(copyOfFilterStates));
      }
      let additionalData = "";
      let newRange = getCurrentModeExtensionAndExtRange(
        "getExtensionRange",
        type
      );
      let currRange = [...selectedRange];
      if (JSON.stringify(newRange) !== JSON.stringify(currRange)) {
        //if previous range not equal to selected range, apply
        setSelectedRange(newRange);
        props.callback({
          key: props.indexName,
          selectedOption: newRange,
          valuesType: props.indexValType,
          type: props.indexType,
          indexCategory: props.indexCategory,
          additionalData: additionalData,
          actualApply: true,
        });
      }
      setPickerOpen(false);
    }
    return;
  };

  const onChangeCalender = (dates, datesString, info) => {
    setCalendarChange(true);
    if (datesString[0] !== "" && datesString[1] !== "") {
      let appliedRange = [...initSelectedRange];
      let newRange = [...datesString];
      if (JSON.stringify(newRange) !== JSON.stringify(appliedRange)) {
        //if previous range not equal to selected range, enable apply button and set new value; else disable apply button
        setDisableApply(false);
        setSelectedRange(datesString);
      } else {
        setDisableApply(true);
      }
    } else {
      setDisableApply(true);
    }
    return;
  };

  const onClickCancel = () => {
    let copyOfFilterStates = JSON.parse(
      JSON.stringify(isControlledFiltersOpen)
    );
    for (const key in copyOfFilterStates) {
      if (key === props.indexName) {
        copyOfFilterStates[key] = false;
        break;
      }
    }
    dispatch(actions.setControlledFiltersOpen(copyOfFilterStates));
    // setSelectedRange(initSelectedRange);
    setPickerOpen(false);
    return;
  };

  const onClickApply = () => {
    let copyOfFilterStates = JSON.parse(
      JSON.stringify(isControlledFiltersOpen)
    );
    for (const key in copyOfFilterStates) {
      if (key === props.indexName) {
        copyOfFilterStates[key] = false;
        break;
      }
    }
    dispatch(actions.setControlledFiltersOpen(copyOfFilterStates));
    // setSelectedRange(newRange);
    setDataApplied(true);
    setPickerOpen(false);
    let additionalData = "";
    props.callback({
      key: props.indexName,
      selectedOption: selectedRange,
      valuesType: props.indexValType,
      type: props.indexType,
      indexCategory: props.indexCategory,
      additionalData: additionalData,
      actualApply: true,
    });
    return;
  };

  const extraFooterRender = (mode) => {
    return (
      <div>
        <div
          className={
            modeExtensions.length !== 0 &&
            !(
              modeExtensions.length < 2 &&
              modeExtensions.includes(
                datePickerConfigs.modeExtension.CUSTOM_RANGE
              )
            )
              ? "picker-footer-with-ext"
              : "picker-footer"
          }
        >
          <Row style={{ width: "100%" }}>
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={mode !== "date" ? 16 : 18}
              xl={mode !== "date" ? 16 : 18}
              xxl={mode !== "date" ? 16 : 18}
            >
              <span>
                {[
                  selectedRange[0] +
                    " - " +
                    selectedRange[selectedRange.length - 1],
                ]}
              </span>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={mode !== "date" ? 4 : 3}
              xl={mode !== "date" ? 4 : 3}
              xxl={mode !== "date" ? 4 : 3}
            >
              <Button
                className="rangepicker_btnCancel"
                type="button"
                onClick={onClickCancel}
              >
                Cancel
              </Button>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={mode !== "date" ? 4 : 3}
              xl={mode !== "date" ? 4 : 3}
              xxl={mode !== "date" ? 4 : 3}
            >
              <Button
                className="rangepicker_btnApply"
                type="primary"
                disabled={disableApply}
                onClick={onClickApply}
              >
                Apply
              </Button>
            </Col>
          </Row>
        </div>
        {modeExtensions.length !== 0 &&
        !(
          modeExtensions.length < 2 &&
          modeExtensions.includes(datePickerConfigs.modeExtension.CUSTOM_RANGE)
        ) ? (
          <ul>
            {modeExtensions.includes(
              datePickerConfigs.modeExtension.BUSINESS_DATE
            ) === true ? (
              <li>
                <div
                  className={classNames(
                    "_ext_" + datePickerConfigs.modeExtension.BUSINESS_DATE,
                    currentModeExtension ===
                      datePickerConfigs.modeExtension.BUSINESS_DATE
                      ? "active"
                      : ""
                  )}
                  onClick={(e) =>
                    onClickExtension(
                      datePickerConfigs.modeExtension.BUSINESS_DATE
                    )
                  }
                >
                  Business Date
                </div>
              </li>
            ) : (
              ""
            )}
            {modeExtensions.includes(
              datePickerConfigs.modeExtension.LAST_SEVEN_DAYS
            ) === true ? (
              <li>
                <div
                  className={classNames(
                    "_ext_" + datePickerConfigs.modeExtension.LAST_SEVEN_DAYS,
                    currentModeExtension ===
                      datePickerConfigs.modeExtension.LAST_SEVEN_DAYS
                      ? "active"
                      : ""
                  )}
                  onClick={(e) =>
                    onClickExtension(
                      datePickerConfigs.modeExtension.LAST_SEVEN_DAYS
                    )
                  }
                >
                  Last 7 Days
                </div>
              </li>
            ) : (
              ""
            )}
            {modeExtensions.includes(
              datePickerConfigs.modeExtension.LAST_THIRTY_DAYS
            ) === true ? (
              <li>
                <div
                  className={classNames(
                    "_ext_" + datePickerConfigs.modeExtension.LAST_THIRTY_DAYS,
                    currentModeExtension ===
                      datePickerConfigs.modeExtension.LAST_THIRTY_DAYS
                      ? "active"
                      : ""
                  )}
                  onClick={(e) =>
                    onClickExtension(
                      datePickerConfigs.modeExtension.LAST_THIRTY_DAYS
                    )
                  }
                >
                  Last 30 Days
                </div>
              </li>
            ) : (
              ""
            )}
            {modeExtensions.includes(
              datePickerConfigs.modeExtension.THIS_MONTH
            ) === true ? (
              <li>
                <div
                  className={classNames(
                    "_ext_" + datePickerConfigs.modeExtension.THIS_MONTH,
                    currentModeExtension ===
                      datePickerConfigs.modeExtension.THIS_MONTH
                      ? "active"
                      : ""
                  )}
                  // className={this.state.activeNow === 'this_month' ? 'active' : null}
                  onClick={(e) =>
                    onClickExtension(datePickerConfigs.modeExtension.THIS_MONTH)
                  }
                >
                  This Month
                </div>
              </li>
            ) : (
              ""
            )}
            {modeExtensions.includes(
              datePickerConfigs.modeExtension.LAST_MONTH
            ) === true ? (
              <li>
                <div
                  className={classNames(
                    "_ext_" + datePickerConfigs.modeExtension.LAST_MONTH,
                    currentModeExtension ===
                      datePickerConfigs.modeExtension.LAST_MONTH
                      ? "active"
                      : ""
                  )}
                  onClick={(e) =>
                    onClickExtension(datePickerConfigs.modeExtension.LAST_MONTH)
                  }
                >
                  Last Month
                </div>
              </li>
            ) : (
              ""
            )}
            {modeExtensions.includes(
              datePickerConfigs.modeExtension.LAST_TWO_MONTHS
            ) === true ? (
              <li>
                <div
                  className={classNames(
                    "_ext_" + datePickerConfigs.modeExtension.LAST_TWO_MONTHS,
                    currentModeExtension ===
                      datePickerConfigs.modeExtension.LAST_TWO_MONTHS
                      ? "active"
                      : ""
                  )}
                  onClick={(e) =>
                    onClickExtension(
                      datePickerConfigs.modeExtension.LAST_TWO_MONTHS
                    )
                  }
                >
                  Last 2 Months
                </div>
              </li>
            ) : (
              ""
            )}
            {modeExtensions.includes(
              datePickerConfigs.modeExtension.CUSTOM_RANGE
            ) === true ? (
              <li>
                <div
                  className={classNames(
                    "_ext_" + datePickerConfigs.modeExtension.CUSTOM_RANGE,
                    currentModeExtension ===
                      datePickerConfigs.modeExtension.CUSTOM_RANGE
                      ? "active"
                      : ""
                  )}
                  onClick={(e) =>
                    onClickExtension(
                      datePickerConfigs.modeExtension.CUSTOM_RANGE
                    )
                  }
                >
                  Custom Range
                </div>
              </li>
            ) : (
              ""
            )}
          </ul>
        ) : (
          ""
        )}
      </div>
    );
  };

  const setDisabledDate = (d) => {
    if (
      !_.isEmpty(enabledRange) &&
      enabledRange.type !== undefined &&
      enabledRange.type !== "" &&
      enabledRange.val !== undefined &&
      !_.isEmpty(enabledRange.val)
    ) {
      if (enabledRange.type === "min_max") {
        if (enabledRange.val.length > 1) {
          return (
            !d ||
            d.isAfter(moment(enabledRange.val[1], props.format)) ||
            d.isBefore(moment(enabledRange.val[0], props.format))
          );
        } else {
          return !d || d.isAfter(moment(enabledRange.val[0], props.format));
        }
      } else if (enabledRange.type === "adhoc") {
        let finalRes = [];
        for (const iterator of enabledRange.val) {
          finalRes.push(
            !d || d.isSame(moment(iterator, props.format)) === false
          );
        }
        if (finalRes.find((f) => f === false) !== undefined) {
          return false;
        } else {
          return true;
        }
      } else if (enabledRange.type === "config") {
        let configDates = getConfigDate(
          enabledRange.val.scheduleType,
          enabledRange.val.sceduleConf,
          d,
          props.format
        );
        if (configDates.length !== 0) {
          if (
            !d ||
            d.isAfter(moment(enabledRange.val.max[0], props.format)) ||
            configDates.find(
              (c) => d.isSame(moment(c, props.format)) === true
            ) === undefined
          ) {
            // if date not valid or same dates not available = disable true
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
    } else {
      return false;
    }
  };

  const getCurrentModeExtensionAndExtRange = (searchtype, query) => {
    let res;
    let cDate = moment().format(props.format);
    let cBDate = moment().subtract(1, "days").format(props.format);
    let businessDate = [cBDate, cBDate];
    let lastSevenDays =
      props.indexValType === "Date"
        ? [
            moment(cBDate, props.format)
              .subtract(6, "days")
              .format(props.format),
            cBDate,
          ]
        : [
            moment(cDate, props.format)
              .subtract(6, "days")
              .format(props.format),
            cDate,
          ];
    let lastThirtyDays =
      props.indexValType === "Date"
        ? [
            moment(cBDate, props.format)
              .subtract(29, "days")
              .format(props.format),
            cBDate,
          ]
        : [
            moment(cDate, props.format)
              .subtract(29, "days")
              .format(props.format),
            cDate,
          ];
    let thisMonth =
      props.indexValType === "Date"
        ? [
            moment(cBDate, props.format).startOf("month").format(props.format),
            cBDate,
          ]
        : [
            moment(cDate, props.format).startOf("month").format(props.format),
            cDate,
          ];
    let lastMonth =
      props.indexValType === "Date"
        ? [
            moment(cBDate, props.format)
              .subtract(1, "month")
              .startOf("month")
              .format(props.format),
            moment(cBDate, props.format)
              .subtract(1, "month")
              .endOf("month")
              .format(props.format),
          ]
        : [
            moment(cDate, props.format)
              .subtract(1, "month")
              .startOf("month")
              .format(props.format),
            moment(cDate, props.format)
              .subtract(1, "month")
              .endOf("month")
              .format(props.format),
          ];
    let lastTwoMonths =
      props.indexValType === "Date"
        ? [
            moment(cBDate, props.format)
              .subtract(2, "month")
              .startOf("month")
              .format(props.format),
            moment(cBDate, props.format)
              .subtract(1, "month")
              .endOf("month")
              .format(props.format),
          ]
        : [
            moment(cDate, props.format)
              .subtract(2, "month")
              .startOf("month")
              .format(props.format),
            moment(cDate, props.format)
              .subtract(1, "month")
              .endOf("month")
              .format(props.format),
          ];

    if (searchtype === "getExtension") {
      switch (true) {
        case moment(query[0], props.format).isSame(
          moment(businessDate[0], props.format)
        ) &&
          moment(query[1], props.format).isSame(
            moment(businessDate[1], props.format)
          ):
          res = datePickerConfigs.modeExtension.BUSINESS_DATE;
          break;
        case moment(query[0], props.format).isSame(
          moment(lastSevenDays[0], props.format)
        ) &&
          moment(query[1], props.format).isSame(
            moment(lastSevenDays[1], props.format)
          ):
          res = datePickerConfigs.modeExtension.LAST_SEVEN_DAYS;
          break;
        case moment(query[0], props.format).isSame(
          moment(lastThirtyDays[0], props.format)
        ) &&
          moment(query[1], props.format).isSame(
            moment(lastThirtyDays[1], props.format)
          ):
          res = datePickerConfigs.modeExtension.LAST_THIRTY_DAYS;
          break;
        case moment(query[0], props.format).isSame(
          moment(thisMonth[0], props.format)
        ) &&
          moment(query[1], props.format).isSame(
            moment(thisMonth[1], props.format)
          ):
          res = datePickerConfigs.modeExtension.THIS_MONTH;
          break;
        case moment(query[0], props.format).isSame(
          moment(lastMonth[0], props.format)
        ) &&
          moment(query[1], props.format).isSame(
            moment(lastMonth[1], props.format)
          ):
          res = datePickerConfigs.modeExtension.LAST_MONTH;
          break;
        case moment(query[0], props.format).isSame(
          moment(lastTwoMonths[0], props.format)
        ) &&
          moment(query[1], props.format).isSame(
            moment(lastTwoMonths[1], props.format)
          ):
          res = datePickerConfigs.modeExtension.LAST_TWO_MONTHS;
          break;
        default:
          res = datePickerConfigs.modeExtension.CUSTOM_RANGE;
          break;
      }
    } else if (searchtype === "getExtensionRange") {
      switch (query) {
        case datePickerConfigs.modeExtension.BUSINESS_DATE:
          res = businessDate;
          break;
        case datePickerConfigs.modeExtension.LAST_SEVEN_DAYS:
          res = lastSevenDays;
          break;
        case datePickerConfigs.modeExtension.LAST_THIRTY_DAYS:
          res = lastThirtyDays;
          break;
        case datePickerConfigs.modeExtension.THIS_MONTH:
          res = thisMonth;
          break;
        case datePickerConfigs.modeExtension.LAST_MONTH:
          res = lastMonth;
          break;
        case datePickerConfigs.modeExtension.LAST_TWO_MONTHS:
          res = lastTwoMonths;
          break;
        default:
          res = thisMonth;
          break;
      }
    }

    return res;
  };

  const onOpenClosePicker = (e) => {
    let copyOfFilterStates = JSON.parse(
      JSON.stringify(isControlledFiltersOpen)
    );
    if (e) {
      //open picker
      if (props.apply === datePickerConfigs.apply.ONAPPLY) {
        for (const key in copyOfFilterStates) {
          if (key === props.indexName) {
            copyOfFilterStates[key] = e;
          } else {
            copyOfFilterStates[key] = false;
          }
        }
        dispatch(actions.setControlledFiltersOpen(copyOfFilterStates));
      }
      setDisableApply(true); // initially disable the apply button when open though value assigned
      setPickerOpen(true);
      setDataApplied(false);
    } else {
      // closing picker
      if (
        currentModeExtension !== "" &&
        currentModeExtension !== datePickerConfigs.modeExtension.CUSTOM_RANGE
      ) {
        //if not custom_range
        if (props.apply === datePickerConfigs.apply.ONAPPLY) {
          for (const key in copyOfFilterStates) {
            if (key === props.indexName) {
              copyOfFilterStates[key] = false;
              break;
            }
          }
          dispatch(actions.setControlledFiltersOpen(copyOfFilterStates));
        }
        setPickerOpen(false);
        setDataApplied(true);
      }
      // else if(currentModeExtension !== '' && currentModeExtension === datePickerConfigs.modeExtension.CUSTOM_RANGE) { //if custom_range
      //     if (props.apply === datePickerConfigs.apply.ONAPPLY) {
      //         if (calendarChange) {
      //             setCalendarChange(false);
      //         } else{
      //             if (disableApply) { // if Apply button disabled- no date range change done
      //                 setDataApplied(true);
      //             } else {  // if Apply button enabled - date range change done - need to reset range as apply button is not clicked
      //                 setDataApplied(false);
      //             }
      //             for (const key in copyOfFilterStates) {
      //                 if (key === props.indexName) {
      //                     copyOfFilterStates[key] = false;
      //                     break;
      //                 }
      //             }
      //             dispatch(actions.setControlledFiltersOpen(copyOfFilterStates))
      //             setPickerOpen(false);
      //         }
      //     }
      // }
    }

    return;
    // if(e) {
    //     let visibility = currentModeExtension === '' || currentModeExtension === datePickerConfigs.modeExtension.CUSTOM_RANGE ? 'show' : 'hide' ;
    //     setRangeCalandarVisibilityClass(visibility)
    // // }
  };

  useEffect(() => {
    setSelectedRange(props.selectedRange);
    setInitSelectedRange(props.selectedRange);
  }, [props.selectedRange]);

  useEffect(() => {
    setEnabledRange(props.disabledRange);
  }, [props.disabledRange, props.disabledRange.val]);

  useEffect(() => {
    setModeExtensions(props.modeExtensions);
  }, [props.modeExtensions]);

  useEffect(() => {
    if (
      selectedRange.length !== 0 &&
      selectedRange[0] !== "" &&
      selectedRange[1] !== ""
    ) {
      if (
        modeExtensions.length !== 0 &&
        !(
          modeExtensions.length < 2 &&
          modeExtensions.includes(datePickerConfigs.modeExtension.CUSTOM_RANGE)
        )
      ) {
        if (calendarChange) {
          setCalendarChange(false);
        } else {
          let currentModeExt = getCurrentModeExtensionAndExtRange(
            "getExtension",
            selectedRange
          );
          setCurrentModeExtension(currentModeExt);
          setDisableApply(false);
        }
      }
    } else {
      setDisableApply(true);
    }
  }, [selectedRange]);

  useEffect(() => {
    let visibility =
      currentModeExtension === "" ||
      currentModeExtension === datePickerConfigs.modeExtension.CUSTOM_RANGE
        ? "show"
        : "hide";
    setRangeCalandarVisibilityClass(visibility);
  }, [currentModeExtension]);

  useLayoutEffect(() => {
    if (initSelectedRange.length !== 0) {
      if (!pickerOpen) {
        //if picker closing
        if (!dataApplied) {
          //if selection not applied - reset the selection to previous applied selection
          setSelectedRange(initSelectedRange);
        }
      }
    }
  }, [pickerOpen]);

  useLayoutEffect(() => {
    if (isControlledFiltersOpen[props.indexName] !== undefined) {
      if (pickerOpen !== isControlledFiltersOpen[props.indexName]) {
        setPickerOpen(isControlledFiltersOpen[props.indexName]);
      }
    }
  }, [isControlledFiltersOpen]);

  return (
    <RangePicker
      key={props.key}
      suffixIcon={<CaretDownOutlined className="ant-picker-suffix" />}
      picker={props.pickerType}
      placeholder={props.placeholder}
      format={props.format}
      showToday={false}
      style={{ width: "100%" }}
      separator="-"
      allowClear={false}
      inputReadOnly={true}
      dropdownClassName={classNames(
        rangeCalandarVisibilityClass,
        modeExtensions.length !== 0 &&
          !(
            modeExtensions.length < 2 &&
            modeExtensions.includes(
              datePickerConfigs.modeExtension.CUSTOM_RANGE
            )
          )
          ? "with-ext"
          : ""
      )}
      disabledDate={(d) => setDisabledDate(d)}
      value={[
        moment(selectedRange[0], props.format),
        moment(selectedRange[selectedRange.length - 1], props.format),
      ]}
      renderExtraFooter={(mode) => extraFooterRender(mode)}
      onOpenChange={onOpenClosePicker}
      open={isControlledFiltersOpen[props.indexName]}
      onCalendarChange={(dates, datesString, info) =>
        onChangeCalender(dates, datesString, info)
      }
    />
  );
};

export default React.memo(Rangepicker);
